module.exports = __webpack_public_path__ + "static/media/logo.4d5852a6.png";